import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden" data-id="element-169">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/wrif2SzPzaXgRaFVQfvwPa/IMAGEN_5_LEYES_(PORTADA).png")',
      backgroundPosition: 'center 20%'
    }} data-id="element-170" />
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-forest-dark/70 via-forest-dark/50 to-forest-dark/90" data-id="element-171" />
      <div className="absolute inset-0 z-10 bg-gradient-radial from-gold/10 to-transparent opacity-60" data-id="element-172" />

      {/* Content */}
      <div className="relative z-20 container mx-auto px-6 py-20 text-center flex flex-col items-center" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="mb-6" data-id="element-174">
          <span className="inline-block py-1 px-3 border border-gold/50 rounded-full text-gold-light text-sm tracking-widest uppercase mb-6 font-medium bg-forest-dark/30 backdrop-blur-sm" data-id="element-175">
            Nueva Medicina Germánica
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="font-display text-5xl md:text-7xl lg:text-8xl text-parchment-light font-bold mb-6 drop-shadow-lg max-w-5xl leading-tight" data-id="element-176">
          Del Dolor a la <span className="text-gold" data-id="element-177">Conciencia</span>
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="font-display text-2xl md:text-4xl text-gold-light mb-10 drop-shadow-md max-w-3xl italic" data-id="element-178">
          Las Cinco Leyes para Transformar tu Vida
        </motion.h2>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="flex flex-col items-center" data-id="element-179">
          <p className="text-parchment-light/80 text-lg md:text-xl mb-2 tracking-wide" data-id="element-180">
            Una obra de
          </p>
          <p className="font-display text-3xl text-parchment-light font-semibold tracking-wider" data-id="element-181">
            Rosana G.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 1.2,
        repeat: Infinity,
        repeatType: 'reverse'
      }} className="absolute bottom-10 left-1/2 -translate-x-1/2" data-id="element-182">
          <div className="w-[1px] h-16 bg-gradient-to-b from-gold to-transparent" data-id="element-183" />
        </motion.div>
      </div>
    </section>;
}